import axios from "axios";

// Base API configuration
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:3001", // Replace with your API base URL
  headers: {
    "Content-Type": "application/json",
  },
});

// Add a request interceptor to include the token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export const checkBranchOtp = async () => {
  const response = await apiClient.post("/auth/check-device");
  return response;
};

export const registerAdmin = async (data) => {
  data.action = "register-admin-device";
  const response = await apiClient.post("/device/register", data);
  return response;
};

export const registerBranchInit = async (data) => {
  data.action = "register-branch-device-init";
  const response = await apiClient.post("/device/register", data);
  return response;
};

export const registerBranch = async (data) => {
  data.action = "register-branch-device";
  const response = await apiClient.post("/device/register", data);
  return response;
};

export const unregisterBranch = async (data) => {
  data.action = "unregister-branch-device";
  const response = await apiClient.post("/device/register", data);
  return response;
};

export const addBranch = async (data) => {
  data.action = "create-branch";
  const response = await apiClient.post("/branch", data);
  return response;
};

export const addProduct = async (data) => {
  const response = await apiClient.post("/product", data);
  return response;
};

export const updateProduct = async (data) => {
  const { product, ...rest } = data;
  const response = await apiClient.patch(`/product/${product}`, rest);
  return response;
};

export const addStock = async (data) => {
  const response = await apiClient.post("/stock", data);
  return response;
};

export const fetchStock = async ({ product }) => {
  const params = new URLSearchParams({
    limit: 100,
    ...(product && { product }),
  });

  const response = await apiClient.get(`/stock?${params.toString()}`);
  return response.data;
};

export const fetchGas = async ({ branch }) => {
  const params = new URLSearchParams({
    action: "get-gas",
    ...(branch && { branch }),
  });

  const response = await apiClient.get(`/branch?${params.toString()}`);
  return response.data;
};

export const resetGas = async (data) => {
  data.action = "reset-gas";
  const response = await apiClient.post("/branch", data);
  return response;
};

export const login = async (credentials) => {
  const response = await apiClient.post("/auth/login", credentials);
  return response;
};

export const fetchUsers = async () => {
  const params = new URLSearchParams({
    limit: 500,
  });

  const response = await apiClient.get(`/user?${params.toString()}`);
  return response.data;
};

export const updatePassword = async (data) => {
  const { user, ...rest } = data;
  const response = await apiClient.patch(`/user/${user}`, rest);
  return response;
};

export const fetchBranches = async () => {
  const params = new URLSearchParams({
    limit: 500,
  });

  const response = await apiClient.get(`/branch?${params.toString()}`);
  return response.data;
};

export const fetchProducts = async ({ branch }) => {
  const params = new URLSearchParams({
    limit: 500,
    ...(branch && { branch }),
  });

  const response = await apiClient.get(`/product?${params.toString()}`);
  return response.data;
};

export const fetchTransactions = async ({
  startDate,
  startTime,
  endDate,
  endTime,
  branch,
  shift,
  user,
  page,
  limit,
}) => {
  const params = new URLSearchParams({
    ...(startDate && { startDate }),
    ...(startTime && { startTime }),
    ...(endDate && { endDate }),
    ...(endTime && { endTime }),
    ...(branch && { branch }),
    ...(shift && { shift }),
    ...(user && { user }),
    ...(page && { page }),
    ...(limit && { limit }),
  });

  const response = await apiClient.get(`/transaction?${params.toString()}`);
  return response.data;
};

export const createTransaction = async (data) => {
  const response = await apiClient.post("/transaction", data);
  return response;
};

export const deleteTransaction = async (data) => {
  const { transaction, ...rest } = data;
  const response = await apiClient.delete(`/transaction/${transaction}`, rest);
  return response;
};

export default apiClient;
